import { useState, useEffect } from "react";
import { ReportDefaults } from "./useNovaObra";
import { getObraReportDefaults } from "@/services/obraStorageService";

export const useObraReportDefaults = (obraId: string) => {
  const [reportDefaults, setReportDefaults] = useState<ReportDefaults | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadReportDefaults = async () => {
      if (!obraId) {
        setIsLoading(false);
        return;
      }

      try {
        setIsLoading(true);
        setError(null);
        
        // Simulate async operation for consistency
        await new Promise(resolve => setTimeout(resolve, 100));
        
        const defaults = getObraReportDefaults(obraId);
        setReportDefaults(defaults);
      } catch (err) {
        console.error('Error loading report defaults:', err);
        setError('Erro ao carregar configurações do relatório');
        
        // Fallback: all sections enabled
        setReportDefaults({
          condicoesClimaticas: true,
          maoDeObra: true,
          equipamentos: true,
          atividades: true,
          ocorrencias: true,
          materiais: true,
          comentarios: true,
          fotos: true,
          videos: true,
          anexos: true,
        });
      } finally {
        setIsLoading(false);
      }
    };

    loadReportDefaults();
  }, [obraId]);

  return {
    reportDefaults,
    isLoading,
    error,
    // Helper functions to check if specific sections are enabled
    isEnabled: (section: keyof ReportDefaults) => {
      return reportDefaults?.[section] ?? true; // Default to true if not loaded
    }
  };
};